import { render, staticRenderFns } from "./InvoiceDistribution.vue?vue&type=template&id=0e735766&"
import script from "./InvoiceDistribution.vue?vue&type=script&lang=js&"
export * from "./InvoiceDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports